<login-component [successRedirect]="'/site'"></login-component>